// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__38N8m","emptyList":"styles_emptyList__298pP"};